import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    AfterViewInit,
    inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastOptions } from '../models';

@Component({
    selector: 'app-toaster',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './toaster.component.html',
    styleUrl: './toaster.component.sass',
})
export class ToasterComponent implements AfterViewInit {
    private el = inject(ElementRef);

    @Input() toast!: ToastOptions;
    @Input() i = 0;
    @Output() remove = new EventEmitter<number>();
    @Output() rendered = new EventEmitter<HTMLElement>();

    ngAfterViewInit() {
        this.rendered.emit(this.el.nativeElement);
    }

    getPositionClass(): string {
        switch (this.toast.position) {
            case 'top-start':
                return 'toast-position top-0 start-0';
            case 'top-end':
                return 'toast-position top-0 end-0';
            case 'bottom-start':
                return 'toast-position bottom-0 start-0';
            case 'bottom-end':
            default:
                return 'toast-position bottom-0 end-0';
        }
    }
}
